export default __webpack_public_path__ + "240dfcc37f7ef4390d8cd2bc28accf24.svg";